angular.module('SpidApp')

.factory('UserService',
        ['Restangular', 'User',
function (Restangular,   User) {
	
	var UserService = {
		all : function () {
			return Restangular.all('users').getList().then(function (usersData) {
				return _.map(usersData, function (userData) {
					userData.roles = userData.roles.split(',');
					return new User(userData);
				})
			})
		},
		find : function (id) {
			if (id === undefined || id === null) {
				throw 'UserService::find() - Missing parameters'
			}
			return Restangular.one('users', id).get().then(function (userData) {
				userData.roles = userData.roles.split(',');
				return new User(userData)
			})
		},
		findByEmail : function (email) {
            if (email === undefined || email === null) {
                throw 'UserService::findByEmail() - Missing parameters'+email
            }
            return Restangular.one('users').one('email',email).get().then(function (userData) {
                userData.roles = userData.roles.split(',');
                return new User(userData)
            })
        },
		bulkSave : function(users) {
			if (!users) {
				throw 'UserService::bulkSave() - Missing parameters'
			}
			
			var usersData = _.map(users, function(user) {
				var u = new User(user);
				u.roles = user.roles.sort().join();
				return u;
			});
			
			return Restangular.one("users").post(null, usersData);
		},
		changePassword : function (userId, oldPassword, newPassword) {
			if (userId < 1 || !oldPassword || !newPassword) {
				throw 'UserSerivce::changePassword() - Missing parameters'
			}
			
			return Restangular.one('users', userId).all('password').post({
				  oldPassword: oldPassword
				, newPassword: newPassword
			})
		},
		resetPassword : function (email, newPassword) {
			if (!email || !newPassword) {
				throw 'UserSerivce::resetPassword() - Missing parameters'
			}
			
			return Restangular.one('users', email).all('reset').post({
				  email       : email
				, newPassword : newPassword
			})
		},
		expirePassword : function (email) {
			if (!email) {
				throw 'UserSerivce::expirePassword() - Missing parameters'
			}
			
			return Restangular.one('users', email).all('expire').post({
				email : email
			})
		},
		
		deactivate : function (userId) {
			if (userId === null || userId === undefined) {
				throw 'UserSerivce::deactivate() - Missing parameters'
			}
			
			return Restangular.one('users', userId).all('deactivate').post()
		}
	}
	
	return UserService
}])
